import api from '../api';
import { HubConnectionBuilder, HubConnectionState } from '@aspnet/signalr';
import Task from 'src/models/Task';
var TaskUpdateHub = /** @class */ (function () {
    function TaskUpdateHub() {
        var path = api.defaults.baseURL + '/taskupdate';
        this.connection = new HubConnectionBuilder()
            .withUrl(path)
            .build();
    }
    TaskUpdateHub.prototype.connect = function () {
        return this.connection.start();
    };
    TaskUpdateHub.prototype.send = function (taskId) {
        if (this.connection.state === HubConnectionState.Connected) {
            this.connection.send('SendTaskUpdate', taskId);
        }
    };
    TaskUpdateHub.prototype.taskChanged = function (listener) {
        return this.connection.on('ReceiveTaskUpdate', function (dto) {
            listener(new Task(dto));
        });
    };
    TaskUpdateHub.prototype.taskCreated = function (listener) {
        return this.connection.on('ReceiveTaskCreated', function (dto) {
            listener(new Task(dto));
        });
    };
    return TaskUpdateHub;
}());
var TASK_UPDATE_HUB = new TaskUpdateHub();
export { TASK_UPDATE_HUB };



//////////////////
// WEBPACK FOOTER
// ./src/services/Hubs.ts
// module id = 191
// module chunks = 0